import { sendFooterNavigationEvent } from '@kaa/core-app/customers/utils/google-analytics';
import {
  SwButton,
  SwColumn,
  SwGrid,
  SwLayout,
  SwLink,
} from '@kaa/ui-flanders/components';
import logo from '@kaa/ui-flanders/themes/wl/images/logo-footer.svg';
import React from 'react';
import { FooterProps } from '../../../types/footer';
import './Footer.style.scss';

export const FooterWallonia = ({
  title,
  subtitle,
  copyright,
  topLinks,
  bottomLinks,
  url,
  foremLogoAlt,
}: FooterProps) => {
  return (
    <footer>
      <div className="footer--top">
        <SwLayout>
          <SwGrid>
            <SwColumn>
              <div className="footer--wrapper footer--wrapper_top vl-u-display-flex">
                {!!logo && (
                  <div className="logo--wrapper">
                    <SwLink to={url} target="_blank" rel="noopener noreferrer">
                      <img src={logo} alt={foremLogoAlt} className="logo" />
                    </SwLink>
                    <p className="logo--tagline">
                      {title}
                      {!!subtitle && <span>{subtitle}</span>}
                    </p>
                  </div>
                )}
                {topLinks && !!topLinks.length && (
                  <ul className="footer--top_list">
                    {topLinks.map(({ label, url, ...rest }) => (
                      <li key={label}>
                        <SwButton
                          tagName="a"
                          to={url}
                          title={label}
                          {...rest}
                          onClick={() =>
                            sendFooterNavigationEvent(label, url, label)
                          }
                        >
                          {label}
                        </SwButton>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </SwColumn>
          </SwGrid>
        </SwLayout>
      </div>
      <div className="footer--bottom">
        <SwLayout>
          <SwGrid>
            <SwColumn>
              <div className="footer--wrapper vl-u-display-flex">
                <p className="copyright">{copyright}</p>
                {bottomLinks && !!bottomLinks.length && (
                  <ul className="footer--bottom_list">
                    {bottomLinks.map(({ label, url, ...rest }) => (
                      <li key={label}>
                        <SwLink
                          to={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={label}
                          {...rest}
                          onClick={() =>
                            sendFooterNavigationEvent(label, url, label)
                          }
                        >
                          {label}
                        </SwLink>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </SwColumn>
          </SwGrid>
        </SwLayout>
      </div>
    </footer>
  );
};
